import { createContext, useContext } from 'react';
import type { SnackbarContextType } from './snackbar.types';

export const SnackbarContext = createContext<SnackbarContextType>({
  showSnackbar: () => {},
  showSuccess: () => {},
  showError: () => {},
  showWarning: () => {},
  showInfo: () => {},
  hideSnackbar: () => {},
});

export const useSnackbarContext = () => useContext(SnackbarContext);
